/**
 * Link PROD các hệ thống — mở tab mới từ dropdown account.
 * Cố định PROD (không theo env local/dev).
 */
export type HeThongProdLink = {
  id: string
  labelKey: string
  href: string
}

export const HE_THONG_PROD_LINKS: HeThongProdLink[] = [
  { id: 'phanQuyen', labelKey: 'components.menu.phanQuyen', href: 'https://auth.letrangroup.vn' },
  { id: 'muaHang', labelKey: 'components.menu.muaHang', href: 'https://muahang.letrangroup.vn' },
  { id: 'vanChuyen', labelKey: 'components.menu.transport', href: 'https://ytl.vn' },
  { id: 'banHang', labelKey: 'components.menu.banHang', href: 'https://banhang.letrangroup.vn' },
  { id: 'sanXuat', labelKey: 'components.menu.sanXuat', href: 'https://sanxuat.letrangroup.vn' },
]
